import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.inventory
        ? _c(
            "div",
            [
              _c(
                VSheet,
                {
                  staticClass: "ma-0 ma-md-2 pa-4 text-center",
                  attrs: { elevation: 2 },
                },
                [
                  _c(
                    "div",
                    [
                      _vm.editLocation
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column flex-md-row justify-space-around",
                            },
                            [
                              _c(VAutocomplete, {
                                attrs: {
                                  label: "Inventory Location",
                                  placeholder:
                                    "Choose a location for inventory",
                                  items: _vm.locations,
                                  "item-text": "name",
                                  "item-value": "id",
                                  clearable: "",
                                  solo: "",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.inventory.locationId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.inventory, "locationId", $$v)
                                  },
                                  expression: "inventory.locationId",
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "mt-4 mt-md-0" },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "ml-4",
                                      attrs: { color: "primary" },
                                      on: { click: _vm.updateLocation },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$vuetify.lang.t(
                                              "$vuetify.base.save"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "ml-4",
                                      on: {
                                        click: function ($event) {
                                          _vm.editLocation = false
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$vuetify.lang.t(
                                              "$vuetify.base.cancel"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            VBtn,
                            {
                              attrs: { text: "" },
                              on: {
                                click: function ($event) {
                                  _vm.editLocation = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.inventory.locationName
                                      ? _vm.inventory.locationName
                                      : "No Location"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                      _vm.editLocation ? _c(VDivider) : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "text-subtitle-2 ma-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.inventory.productName) +
                        " (" +
                        _vm._s(_vm.translateStatus(_vm.inventory.status)) +
                        ") "
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex justify-space-between text-caption",
                    },
                    [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$vuetify.lang.t("$vuetify.label.id")) +
                            ": " +
                            _vm._s(_vm.inventory.id) +
                            " "
                        ),
                      ]),
                      _c(VDivider, {
                        staticClass: "mx-2",
                        attrs: { vertical: "" },
                      }),
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$vuetify.lang.t(
                                "$vuetify.inventory.documentNo"
                              )
                            ) +
                            ": " +
                            _vm._s(_vm.inventory.documentNumber) +
                            " "
                        ),
                      ]),
                      _c(VDivider, {
                        staticClass: "mx-2",
                        attrs: { vertical: "" },
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatDateYear")(_vm.inventory.stockTime)
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(VDivider),
                  _c(
                    "div",
                    { staticClass: "text-subtitle-1 ma-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-space-between" },
                        [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.inventory.weight"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c(
                            "span",
                            { staticStyle: { width: "250px" } },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex justify-space-between" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.inventory.original"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.inventory.quantity
                                        )
                                      ) +
                                        " " +
                                        _vm._s(
                                          _vm.productInfo
                                            ? _vm.productInfo.measureWeight
                                            : ""
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "d-flex justify-space-between" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.inventory.used"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      " -" +
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            _vm.inventory.quantity -
                                              _vm.inventory.quantityAvailable
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.productInfo
                                            ? _vm.productInfo.measureWeight
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "d-flex justify-space-between" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.inventory.reserved"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      "-" +
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            _vm.reservedQuantity
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.productInfo
                                            ? _vm.productInfo.measureWeight
                                            : ""
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(VDivider),
                              _c(
                                "div",
                                { staticClass: "d-flex justify-space-between" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.inventory.remains"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.inventory.quantityAvailable -
                                            _vm.reservedQuantity
                                        )
                                      ) +
                                        " " +
                                        _vm._s(
                                          _vm.productInfo
                                            ? _vm.productInfo.measureWeight
                                            : ""
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-space-between mt-4" },
                        [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.inventory.OriginalUnit",
                                    _vm.productInfo
                                      ? _vm.productInfo.measureUnit
                                      : ""
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c(
                            "span",
                            [
                              _c("inventory-unit-details", {
                                attrs: { count: _vm.inventory.unit },
                                model: {
                                  value: _vm.inventory,
                                  callback: function ($$v) {
                                    _vm.inventory = $$v
                                  },
                                  expression: "inventory",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._l(_vm.inventory.fields, function (field) {
                        return _c(
                          "div",
                          {
                            key: field.id,
                            staticClass: "d-flex justify-space-between",
                          },
                          [
                            _c("span", [_vm._v(_vm._s(field.field))]),
                            _c("span", [
                              field.type == "Number"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          field.fieldValueNumber
                                        )
                                      )
                                    ),
                                  ])
                                : field.type == "Date"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDateYear")(
                                          field.fieldValueDate
                                        )
                                      )
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(field.fieldValueString)),
                                  ]),
                            ]),
                          ]
                        )
                      }),
                      _vm.coa
                        ? _c(
                            "div",
                            { staticClass: "d-flex justify-space-between" },
                            [
                              _c("span", [_vm._v("CoA")]),
                              _c(
                                "span",
                                [
                                  _c(
                                    VIcon,
                                    {
                                      attrs: { color: "primary" },
                                      on: { click: _vm.openCoaWindow },
                                    },
                                    [_vm._v(" mdi-certificate ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm.nodes &&
              _vm.nodes[0].childrens &&
              _vm.nodes[0].childrens.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "text-center",
                      style: {
                        height: _vm.$vuetify.breakpoint.mobile
                          ? "600px"
                          : "300px",
                        position: "relative",
                      },
                    },
                    [
                      _c("flow-chart", {
                        staticStyle: { position: "relative", "z-index": "1" },
                        attrs: {
                          nodes: _vm.nodes,
                          orientation: _vm.$vuetify.breakpoint.mobile
                            ? "vertical"
                            : "horizontal",
                        },
                        on: { "node-click": _vm.viewNode },
                      }),
                      _vm.selectedWorksheetId
                        ? _c(
                            "div",
                            {
                              staticClass: "text-center",
                              staticStyle: {
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                "z-index": "2",
                                "background-color": "white",
                              },
                            },
                            [
                              _c(
                                VBtn,
                                {
                                  attrs: { text: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.selectedWorksheetId = null
                                    },
                                  },
                                },
                                [_vm._v(" Close ")]
                              ),
                              _c("worksheet-card", {
                                key: _vm.selectedWorksheetId,
                                staticClass: "mb-4",
                                attrs: { worksheet: _vm.selectedWorksheetId },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _c(
            VSkeletonLoader,
            _vm._b(
              { attrs: { type: "list-item-two-line" } },
              "v-skeleton-loader",
              _vm.attrs,
              false
            )
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }